import e from "../toDate/index.js";
import t from "../_lib/requiredArgs/index.js";
function u(r) {
  return t(1, arguments), e(r).getFullYear();
}
export {
  u as default
};
//# sourceMappingURL=index.js.map
